import { AddEditContraEntry, AddEditGeneralCreditNoteEntry, AddEditGeneralDebitNoteEntry, AddEditGSTPurchaseEntryRMPM, AddEditGSTPurchaseEntryWithoutInventory, AddEditJVEntry, AddEditPaymentEntry, AddEditReceiptEntry, DeleteContraEntryById, DeleteGeneralCreditNoteEntryById, DeleteGeneralDebitNoteEntryById, DeleteGSTPurchaseEntryRMPMById, DeleteGSTPurchaseEntryWithoutInventoryById, DeleteJVEntryById, DeletePaymentDetailsByPaymentReceiptId, DeleteReceiptDetailsByReceiptId, GetAllAccountLedger, GetAllBankWiseCashBankBookReport, GetAllContraEntry, GetAllDateWiseCashBankBookReportbyBankId, GetAllGeneralCreditNoteEntry, GetAllGeneralDebitNoteEntry, GetAllGroupWiseAccountSummary, GetAllGSTPurchaseEntryRMPM, GetAllGSTPurchaseRegister, GetAllGSTSalesRegister, GetAllJVEntry, GetAllMonthWiseCashBankBookReportbyBankId, GetAllOpeningBalanceReport, GetAllPaymnetEntry, GetAllPendingGRNPurchaseEntry, GetAllPendingInvoiceByPartyId, GetAllPendingInvoiceForPaymentEntryByPartyId, GetAllPendingInvoicePaymentReport, GetAllPurchaseEntryWithoutInventory, GetAllReceiptEntry, GetBankBalanceByBankId, GetContraEntryById, GetContraEntryVoucherNo, GetGeneralCreditNoteEntryById, GetGeneralCreditNoteEntrySRNo, GetGeneralDebitNoteEntryById, GetGeneralDebitNoteEntrySRNo, GetGSTCalculationList, GetGSTPurchaseEntryRMPMById, GetGSTPurchaseEntryWithoutInventoryById, GetGSTPurchseEntrySRNo, GetGSTPurchseWithoutInventoryEntrySRNo, GetJVEntryById, GetJVEntryVoucherNo, GetLastPurchaseRawmaterialRate, GetPaymentDetailsByPaymnetReceiptId, GetPaymentEntryVoucherNo, GetReceiptDetailsByReceiptId, GetReceiptEntryVoucherNo, GetRunningBalanceByPartyId, UpdateGRNEntryToPurchaseEntry } from "../ApiEndPoints.js";
import { axiosGetMultiParams, axiosGetWithencryption, axiosPostWithencryption } from "../AxiosRequests.js";

export default class AccountServices {

    // Receipt Entry
    async getReceiptEntryVoucherNo(request) {
        return axiosGetWithencryption(GetReceiptEntryVoucherNo, request);
    }

    async getAllPendingInvoiceByPartyId(request) {
        return axiosGetWithencryption(GetAllPendingInvoiceByPartyId, request);
    }

    async addEditReceiptEntry(request) {
        return axiosPostWithencryption(AddEditReceiptEntry, request);
    }

    async getAllReceiptEntry(request) {
        return axiosPostWithencryption(GetAllReceiptEntry, request);
    }

    async getReceiptDetailsByReceiptId(request) {
        return axiosGetWithencryption(GetReceiptDetailsByReceiptId, request);
    }

    async deleteReceiptDetailsByReceiptId(request) {
        return axiosGetWithencryption(DeleteReceiptDetailsByReceiptId, request);
    }

    // Payment Entry
    async getPaymentEntryVoucherNo(request) {
        return axiosGetWithencryption(GetPaymentEntryVoucherNo, request);
    }

    async getAllPendingInvoiceForPaymentEntryByPartyId(request) {
        return axiosGetWithencryption(GetAllPendingInvoiceForPaymentEntryByPartyId, request);
    }

    async addEditPaymentEntry(request) {
        return axiosPostWithencryption(AddEditPaymentEntry, request);
    }

    async getAllPaymnetEntry(request) {
        return axiosPostWithencryption(GetAllPaymnetEntry, request);
    }

    async getPaymentDetailsByPaymnetReceiptId(request) {
        return axiosGetWithencryption(GetPaymentDetailsByPaymnetReceiptId, request);
    }

    async deletePaymentDetailsByPaymentReceiptId(request) {
        return axiosGetWithencryption(DeletePaymentDetailsByPaymentReceiptId, request);
    }

    // Contra Entry
    async getContraEntryVoucherNo(request) {
        return axiosGetWithencryption(GetContraEntryVoucherNo, request);
    }

    async addEditContraEntry(request) {
        return axiosPostWithencryption(AddEditContraEntry, request);
    }

    async getAllContraEntry(request) {
        return axiosPostWithencryption(GetAllContraEntry, request);
    }

    async getContraEntryById(request) {
        return axiosGetWithencryption(GetContraEntryById, request);
    }

    async getBankBalanceByBankId(request) {
        return axiosGetWithencryption(GetBankBalanceByBankId, request);
    }

    async deleteContraEntryById(request) {
        return axiosGetWithencryption(DeleteContraEntryById, request);
    }

    // GST Purchase Entry RM PM
    async getGSTPurchseEntrySRNo(request) {
        return axiosGetWithencryption(GetGSTPurchseEntrySRNo, request);
    }

    async getAllPendingGRNPurchaseEntry(request) {
        return axiosPostWithencryption(GetAllPendingGRNPurchaseEntry, request);
    }

    async updateGRNEntryToPurchaseEntry(request) {
        return axiosPostWithencryption(UpdateGRNEntryToPurchaseEntry, request);
    }

    async addEditGSTPurchaseEntryRMPM(request) {
        return axiosPostWithencryption(AddEditGSTPurchaseEntryRMPM, request);
    }

    async getAllGSTPurchaseEntryRMPM(request) {
        return axiosPostWithencryption(GetAllGSTPurchaseEntryRMPM, request);
    }

    async getGSTPurchaseEntryRMPMById(request) {
        return axiosGetWithencryption(GetGSTPurchaseEntryRMPMById, request);
    }

    async getLastPurchaseRawmaterialRate(request) {
        return axiosGetMultiParams(GetLastPurchaseRawmaterialRate, request);
    }

    async deleteGSTPurchaseEntryRMPMById(request) {
        return axiosGetWithencryption(DeleteGSTPurchaseEntryRMPMById, request);
    }

    // GST Purchas Entry Without Inventory
    async getGSTPurchseWithoutInventoryEntrySRNo(request) {
        return axiosGetWithencryption(GetGSTPurchseWithoutInventoryEntrySRNo, request);
    }

    async addEditGSTPurchaseEntryWithoutInventory(request) {
        return axiosPostWithencryption(AddEditGSTPurchaseEntryWithoutInventory, request);
    }

    async getAllPurchaseEntryWithoutInventory(request) {
        return axiosPostWithencryption(GetAllPurchaseEntryWithoutInventory, request);
    }

    async getGSTPurchaseEntryWithoutInventoryById(request) {
        return axiosGetWithencryption(GetGSTPurchaseEntryWithoutInventoryById, request);
    }

    async deleteGSTPurchaseEntryWithoutInventoryById(request) {
        return axiosGetWithencryption(DeleteGSTPurchaseEntryWithoutInventoryById, request);
    }

    // General Debit Note Entry
    async getGeneralDebitNoteEntrySRNo(request) {
        return axiosGetWithencryption(GetGeneralDebitNoteEntrySRNo, request);
    }

    async addEditGeneralDebitNoteEntry(request) {
        return axiosPostWithencryption(AddEditGeneralDebitNoteEntry, request);
    }

    async getAllGeneralDebitNoteEntry(request) {
        return axiosPostWithencryption(GetAllGeneralDebitNoteEntry, request);
    }

    async getGeneralDebitNoteEntryById(request) {
        return axiosGetWithencryption(GetGeneralDebitNoteEntryById, request);
    }

    async deleteGeneralDebitNoteEntryById(request) {
        return axiosGetWithencryption(DeleteGeneralDebitNoteEntryById, request);
    }

    // General Credit Note Entry
    async getGeneralCreditNoteEntrySRNo(request) {
        return axiosGetWithencryption(GetGeneralCreditNoteEntrySRNo, request);
    }

    async addEditGeneralCreditNoteEntry(request) {
        return axiosPostWithencryption(AddEditGeneralCreditNoteEntry, request);
    }

    async getAllGeneralCreditNoteEntry(request) {
        return axiosPostWithencryption(GetAllGeneralCreditNoteEntry, request);
    }

    async getGeneralCreditNoteEntryById(request) {
        return axiosGetWithencryption(GetGeneralCreditNoteEntryById, request);
    }

    async deleteGeneralCreditNoteEntryById(request) {
        return axiosGetWithencryption(DeleteGeneralCreditNoteEntryById, request);
    }

    // J.V. Entry
    async getJVEntryVoucherNo(request) {
        return axiosGetWithencryption(GetJVEntryVoucherNo, request);
    }

    async addEditJVEntry(request) {
        return axiosPostWithencryption(AddEditJVEntry, request);
    }

    async getAllJVEntry(request) {
        return axiosPostWithencryption(GetAllJVEntry, request);
    }

    async getJVEntryById(request) {
        return axiosGetWithencryption(GetJVEntryById, request);
    }

    async deleteJVEntryById(request) {
        return axiosGetWithencryption(DeleteJVEntryById, request);
    }

    // Reports
    async getAllAccountLedger(request) {
        return axiosPostWithencryption(GetAllAccountLedger, request);
    }

    async getAllPendingInvoicePaymentReport(request) {
        return axiosPostWithencryption(GetAllPendingInvoicePaymentReport, request);
    }

    async getRunningBalanceByPartyId(request) {
        return axiosGetWithencryption(GetRunningBalanceByPartyId, request);
    }

    async getAllBankWiseCashBankBookReport(request) {
        return axiosGetMultiParams(GetAllBankWiseCashBankBookReport, request);
    }

    async getAllMonthWiseCashBankBookReportbyBankId(request) {
        return axiosGetMultiParams(GetAllMonthWiseCashBankBookReportbyBankId, request);
    }

    async getAllDateWiseCashBankBookReportbyBankId(request) {
        return axiosPostWithencryption(GetAllDateWiseCashBankBookReportbyBankId, request);
    }

    async getAllGroupWiseAccountSummary(request) {
        return axiosPostWithencryption(GetAllGroupWiseAccountSummary, request);
    }

    async getAllOpeningBalanceReport(request) {
        return axiosPostWithencryption(GetAllOpeningBalanceReport, request);
    }

    async getAllGSTSalesRegister(request) {
        return axiosPostWithencryption(GetAllGSTSalesRegister, request);
    }

    async getAllGSTPurchaseRegister(request) {
        return axiosPostWithencryption(GetAllGSTPurchaseRegister, request);
    }

    async getGSTCalculationList(request) {
        return axiosPostWithencryption(GetGSTCalculationList, request);
    }
}

